import React, { forwardRef, useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import Avatar from '../Avatar';
import styles from './styles.module.css';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import blankGroup from '../../../../assets/imgs/blank-group-picture.png';

import Api from '../../api';
import UserMoreBox from '../UserMoreBox';
import AppIcons from '../../icons';
import TimeFunction from '../../functions/TimeFunction';
import CenterModal from '../CenterModal';
import WebcamComponent from '../WebcamComponent';
import AppEmojiIcons from '../../icons/emojiIcons';
import FooterMoreBox from '../FooterMoreBox';

const ActiveChatInfo = forwardRef((props, ref) => {
  const {
    activeUser,
    setUpdateSocket,
    setActiveUser,
    openBox,
    setopenBox,
    sharedUser,
    setSharedUser,
    userChannelId,
    setUserChannelId,
    setShowUsers,
    setShowAbsolute,
    direction,
    content,
    privateUsers,
    setPrivateUsers,
    setOpenCreateGroup,
    setGroupState,
    setTrigger,
    showFirstMessage,
    lang,
    setSharedUserClicked,
    setShowUserInfo,
  } = useContext(AdminContext);
  const [showWebcam, setShowWebCam] = useState(false);
  const clickItem = (item, user) => {
    if (item?.id == 1) {
      pinFuncton(user);
    }
    if (item?.id == 2) {
      deleteFunction(user);
    }
    if (item?.id == 3) {
      blockFunction(user);
    }
    if (item?.id == 4) {
      setOpenCreateGroup(true);
      setGroupState(user);
    }
    if (item?.id == 5) {
      leaveGroupFunction(user);
    }
    if (item?.id == 6) {
      setTrigger('groupMember');
    }
    if (item?.id == 7) {
      clearHistoryFunction(user);
    }
    if (item?.id == 8) {
      muteFunction(user);
    }
    setopenBox(false);
  };

  const pinFuncton = (x) => {
    console.log('xxxxxxxx', x);
    Api.pinUser(x?.id)
      .then((res) => {
        setUpdateSocket('user');
        setopenBox(false);

        setActiveUser({ ...activeUser, pin: x.pin == 1 ? 0 : 1 });
      })
      .catch((err) => {});
  };
  const muteFunction = (x) => {
    console.log('xxxxxxxx', x);
    Api.muteUser(x?.id)
      .then((res) => {
        // setUpdateSocket('user');
        setopenBox(false);

        setActiveUser({ ...activeUser, mute: x.mute == 1 ? 0 : 1 });
      })
      .catch((err) => {});
  };
  const clearHistoryFunction = (x) => {
    console.log('xxxxxxxx', x);
    Api.clearHistory(x?.id)
      .then((res) => {
        props?.setMessages([]);
        setopenBox(false);
      })
      .catch((err) => {});
  };
  const deleteFunction = (x) => {
    console.log(
      'xx',
      x?.users?.[0]?.channelUser?.uuid ==
        sharedUser?.users?.[0]?.channelUser?.uuid
    );

    Api.deleteUser(x?.id)
      .then((res) => {
        // setUpdateSocket('user');

        if (
          x?.users?.[0]?.channelUser?.uuid ==
          sharedUser?.users?.[0]?.channelUser?.uuid
        ) {
          setSharedUser();
        }
        if (x?.users?.[0]?.channelUser?.uuid == userChannelId) {
          props?.setMessages([]);
          setUserChannelId('');
          setActiveUser();
          setShowUsers(true);
          setPrivateUsers([...privateUsers?.filter((m) => m.id != x.id)]);
          // Api.privateChatUsersChat()
          //   .then((res) => {
          //     if (res?.data?.response?.length != 0) {
          //       setUserChannelId(
          //         res?.data?.response?.[0]?.users?.[0]?.channelUser?.channelId
          //       );
          //       setActiveUser(res?.data?.response?.[0]);
          //     } else {
          //       setUserChannelId();
          //       setActiveUser({});
          //     }
          //   })
          //   .catch((err) => {});
        } else {
          setUpdateSocket('user');
        }
        setShowAbsolute(true);
        setopenBox(false);
      })
      .catch((err) => {});
  };
  const blockFunction = (x) => {
    // Api.blockUser(x?.users?.[0]?.channelUserId)
    //   .then((res) => {
    //     setUpdateSocket('user');
    //     setopenBox(false);
    //   })
    //   .catch((err) => {});
    ref?.current?.emit(
      'private:blockUser',
      {
        uuid: x?.users?.[0]?.channelUser?.uuid,
        typeId: x?.typeId,
        roomId: x?.id,
      },
      (data) => {
        console.log('data====', data);
        setActiveUser({ ...activeUser, block: x.block == 1 ? 0 : 1 });
        props?.setServerError('');
        // setUpdateSocket('user');
        // setopenBox(false);
      }
    );
    // if (x?.block == 0) {
    //   ref.current.emit(
    //     'private:disconnect',
    //     { channelId: userChannelId },
    //     (message) => {}
    //   );
    // }
  };

  const leaveGroupFunction = (x) => {
    Api.leaveGroup(x?.id)
      .then((res) => {
        props?.informLeftUser(res?.data?.response?.messageId);
        if (
          x?.users?.[0]?.channelUser?.uuid ==
          sharedUser?.users?.[0]?.channelUser?.uuid
        ) {
          setSharedUser();
        }
        if (x?.users?.[0]?.channelUser?.uuid == userChannelId) {
          props?.setMessages([]);
          setUserChannelId('');
          setActiveUser();
          setShowUsers(true);
          setPrivateUsers([...privateUsers?.filter((m) => m.id != x.id)]);
          ref?.current?.emit(
            'private:disconnect',
            {
              uuid: x?.users?.[0]?.channelUser?.uuid,
              typeId: x?.typeId,
              roomId: x?.id,
            },
            (data) => {
              console.log('data====', data);
              // setUpdateSocket('user');
              // setopenBox(false);
            }
          );
        } else {
          setUpdateSocket('user');
        }
        setShowAbsolute(true);
        setopenBox(false);
      })
      .catch((err) => {});
  };
  const showUserInfoFunction = (uuid) => {
    Api.userList({ params: { uuid: uuid } })
      .then((res) => {
        setShowUserInfo(...res.data.response);
        console.log('userInfo', res?.data?.response);
      })
      .catch((err) => {});
  };
  useEffect(() => {}, [activeUser]);

  return (
    <div className={styles.container}>
      <div
        className={`flex flex-row justify-between items-center h-auto w-full  my-[5px] cursor-pointer ${`userBoxStyle`} relative `}
      >
        {!showFirstMessage && (
          <>
            <div className={`flex flex-row justify-start items-center `}>
              {/* <AppIcons.ArrowLeftIcon
            onClick={() => {
              setUserChannelId('');
              setActiveUser();
              setShowUsers(true);
            }}
          /> */}
              <AppIcons.ArrowLeftIconGray
                onClick={() => {
                  setShowUsers(true);
                  setActiveUser();
                  ref.current.emit(
                    'private:disconnect',
                    {
                      uuid: userChannelId,
                      typeId: activeUser?.typeId,
                      roomId: activeUser?.id,
                    },
                    (message) => {}
                  );
                  setUserChannelId('');
                  setShowAbsolute(true);
                }}
                className={`${
                  direction == 'rtl' && 'rotate-180'
                } cursor-pointer ${styles.arrow} ${
                  direction == 'rtl' ? styles.marginRtl : styles.marginLtr
                }`}
                width={14}
                height={19}
              />
              <Avatar
                width={34}
                height={34}
                containerclassName={`relative cursor-pointer roundBox`}
                className={`cursor-pointer roundBox`}
                src={
                  activeUser?.users?.[0]?.channelUser?.image?.name
                    ? activeUser?.users?.[0]?.channelUser?.image?.name
                    : activeUser?.typeId == 2
                    ? blankGroup
                    : blanckUser
                }
                local={!activeUser?.users?.[0]?.channelUser?.image?.name}
                onClick={() => {
                  showUserInfoFunction(userChannelId);
                }}
              ></Avatar>
              <div
                className={`flex flex-col justify-start items-start w-auto h-auto`}
                onClick={() => {
                  showUserInfoFunction(userChannelId);
                }}
              >
                <p className={`text-right mr-[5px]`}>
                  {activeUser?.users?.[0]?.channelUser?.channelName
                    ? activeUser?.users?.[0]?.channelUser?.channelName
                    : activeUser?.users?.[0]?.channelUser?.username}
                </p>
                {activeUser?.users?.[0]?.channelUser?.lastActive && (
                  <p className={`text-right mr-[5px] ${styles.activeTime}`}>
                    {activeUser?.users?.[0]?.channelUser?.statusId == 1
                      ? 'online'
                      : TimeFunction(
                          activeUser?.users?.[0]?.channelUser?.lastActive,
                          lang
                        )}
                  </p>
                )}
              </div>
            </div>

            {activeUser?.users?.[0]?.channelUser?.uuid && (
              <div
                className={`flex flex-row justify-start items-start`}
                className={`flex flex-row justify-center items-center `}
              >
                {/* <div className={`}  ${styles.boxWidth}`} ref={footerMoreRef}> */}
                <FooterMoreBox
                // setFooterMoreIcon={setFooterMoreIcon}
                />
                {/* </div> */}
                <AppEmojiIcons.StarFullIcon
                  width={'22px'}
                  height={'22px'}
                  fill={`#898989`}
                  onClick={() => {
                    setTrigger('favList');
                  }}
                  className={`${styles.favIcon}`}
                />
                {/* <AppIcons.webcamIcon className={`${styles.webcamIcon } `} onClick={()=>{setShowWebCam(true)}}/> */}
                <UserMoreBox
                  user={activeUser}
                  openBox={openBox}
                  setopenBox={setopenBox}
                  content={content}
                  clickItem={clickItem}
                />
              </div>
            )}
          </>
        )}
      </div>
      {showWebcam && <WebcamComponent />}
      {/* <Avatar
        width={34}
        height={34}
        containerclassName={`cursorDefault relative`}
        className={`cursorDefault`}
        src={
          activeUser?.users?.[0]?.channelUser?.imageName
            ? activeUser?.users?.[0]?.channelUser?.imageName
            : blanckUser
        }
        local={!activeUser?.users?.[0]?.channelUser?.imageName}
      ></Avatar>
      <p className={`text-right mr-[5px]`}>
        {activeUser?.users?.[0]?.channelUser?.channelName
          ? activeUser?.users?.[0]?.channelUser?.channelName
          : activeUser?.users?.[0]?.channelUser?.username}
      </p> */}
    </div>
  );
});
export default ActiveChatInfo;
